var $ = require('lib/bling');
var mapRange = require('lib/mapRange');
var isMobile = require('lib/isMobile');
var requestAnimationFrame = require('lib/requestAnimationFrame');

// .....................
// === Marquee Class ===
// ^^^^^^^^^^^^^^^^^^^^^
var Marquee = function({el, movementRange, orientationRange}) {
	this.$el = $(el);
	this.movementRange = movementRange;
	this.orientationRange = orientationRange;
	this.initialize();
};

Marquee.prototype = {
	transitionToAnimation: true,
	isAnimating: false,


	// ....................
	// === Get Position ===
	// ^^^^^^^^^^^^^^^^^^^^
	getMouseTransform([mouseX, mouseY], i) {
		var xPosition = mouseX / window.innerWidth;
		var yPosition = mouseY / window.innerHeight;
		var combinedPosition = (xPosition + yPosition) / 2;
		var transform = mapRange(combinedPosition, 0, 1, 50 - (this.movementRange / 2), 50 + (this.movementRange / 2));

		if (i % 2 === 0) {
			return transform - 100;
		} else {
			return -transform;
		}
	},

	getGammaTransform(gamma, i) {
		var transform = mapRange(gamma, 0, 360, 50 - (this.orientationRange / 2), 50 + (this.orientationRange / 2));

		if (i % 2 === 0) {
			return transform - 100;
		} else {
			return -transform;
		}
	},


	// ....................
	// === Set Position ===
	// ^^^^^^^^^^^^^^^^^^^^
	setMarqueePositionGamma(gamma) {
		this.$el.forEach(($line, i) => {
			var position = this.getGammaTransform(gamma, i);
			$line.style.transform = `translateX(${position}%)`;
		});
	},

	setMarqueePositionMouse([pageX, pageY]) {
		this.$el.forEach(($line, i) => {
			var position = this.getMouseTransform([pageX, pageY], i);
			$line.style.transform = `translateX(${position}%)`;
		});
	},

	// ....................
	// === Updaaaaaaate ===
	// ^^^^^^^^^^^^^^^^^^^^
	requestUpdate(isGamma, e) {
		if (this.isAnimating) { return; }
		this.isAnimating = true;

		if (this.transitionToAnimation) { this.removeInitialTransition(); }

		requestAnimationFrame(() => {
			if (isGamma) {
				this.setMarqueePositionGamma(e.gamma);
			} else {
				this.setMarqueePositionMouse([e.pageX, e.pageY]);
			}
			this.isAnimating = false;
		});
	},

	// ....................
	// === Transitionss ===
	// ^^^^^^^^^^^^^^^^^^^^
	addIntialTransition() {
		this.$el.forEach($line => {$line.style.transition = 'all 100ms ease'; });
	},

	removeInitialTransition() {
		setTimeout(() => {
			this.$el.forEach($line => {$line.style.transition = ''; });
		}, 200);
		this.transitionToAnimation = false;
	},

	initialize() {
		this.addIntialTransition();
		if (isMobile) {
			window.on('deviceorientation', this.requestUpdate.bind(this, true));
		} else {
			window.on('mousemove', this.requestUpdate.bind(this, false));
		}
	}
};

module.exports = Marquee;


// WEBPACK FOOTER //
// ./src/marquee.js